export default __webpack_public_path__ + "64187891a66ef523010c94075ce148a3.jpg";